import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Ticket } from "@/hooks/use-event-data";
import { useIsMobile } from "@/hooks/use-mobile";

interface TicketType {
  id: string;
  name: string;
  price: number;
  description: string;
}

interface ConfirmationScreenProps {
  eventTitle: string;
  eventDate: string;
  selectedTicketType: Ticket | undefined;
  quantity: number;
  totalAmount: number;
  onRegisterAnother: () => void;
  eventPrice: string;
}

const ConfirmationScreen: React.FC<ConfirmationScreenProps> = ({
  eventTitle,
  eventDate,
  selectedTicketType,
  quantity,
  totalAmount,
  onRegisterAnother,
  eventPrice,
}) => {
  const isMobile = useIsMobile();
  return (
    <div className="py-8 text-center space-y-6">
      <div className="h-16 w-16 rounded-full bg-green-100 flex items-center justify-center mx-auto">
        <svg
          className="h-8 w-8 text-green-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      <div>
        <h2 className="text-2xl font-bold text-green-700">
          Registration Complete!
        </h2>
        <p className="text-gray-600 mt-2">
          Thank you for registering for {eventTitle}. A confirmation has been
          sent to your email.
        </p>
      </div>

      <div className="border rounded-md p-6 max-w-md mx-auto text-left bg-gray-50">
        <h3 className="font-bold text-lg mb-4">Registration Details</h3>
        <div className="space-y-2">
          <div className="flex justify-between">
            <span className="text-gray-600">Event:</span>
            <span className="font-medium">{eventTitle}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Date:</span>
            <span className="font-medium">
              {new Date(eventDate).toLocaleDateString("en-US", {
                weekday: isMobile ? "short" : "long",
                year: "numeric",
                month: isMobile ? "short" : "long",
                day: "numeric",
              })}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Ticket:</span>
            <span className="font-medium">
              {selectedTicketType?.price} x {quantity}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Order Total:</span>
            <span className="font-bold">${totalAmount.toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Confirmation #:</span>
            <span className="font-medium">
              CEC-{Math.floor(Math.random() * 10000000)}
            </span>
          </div>
        </div>
      </div>

      <div className="space-x-4">
        <Button type="button" variant="outline" onClick={onRegisterAnother}>
          Register Another Attendee
        </Button>
        <Link to="/">
          <Button>Back to Home</Button>
        </Link>
      </div>
    </div>
  );
};

export default ConfirmationScreen;
